var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDecline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.5 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.5,0c1.98,0,3.3.76,3.48,1.97.62.38,1.01,1.05,1.02,1.78,0,.4-.12.79-.33,1.13.53.37.84.97.83,1.62,0,.55-.23,1.08-.63,1.46.39.42.62.97.63,1.54,0,.07,0,.14,0,.21-.06,1.05-.95,1.85-2,1.79h-3.55c.44.51.79,1.09,1.03,1.72.32.79.35,1.66.1,2.47-.19.73-.82,1.26-1.57,1.31-.99,0-1.46-.82-1.96-1.7-.47-.91-1.1-1.73-1.86-2.42-2.08-1.78-3.68-3.34-3.68-5.85v-2.88c.03-.94.37-1.84.96-2.57C1.82.52,3.14-.06,4.5,0h4Zm-.37,15.36c.33-.94.02-2.6-1.94-4.18-.19-.15-.24-.41-.13-.62.11-.21.35-.32.58-.25.49.12.98.18,1.49.19h3.38c.07,0,.13,0,.2,0,.5-.05.86-.5.8-1-.06-.5-.33-.95-.74-1.23-.14-.11-.21-.29-.18-.46.02-.17.14-.32.3-.39.37-.15.62-.52.62-.93,0-.31-.09-.71-.82-1.05-.16-.07-.27-.23-.28-.4-.02-.18.06-.35.2-.45.26-.2.41-.52.41-.85-.04-.44-.31-.84-.71-1.04-.18-.09-.29-.27-.29-.46,0-.99-1.57-1.25-2.5-1.25h-4s-.07,0-.11,0c-1.81-.07-3.33,1.34-3.39,3.15v2.88c0,2.08,1.38,3.43,3.33,5.09.85.76,1.55,1.67,2.08,2.68.49.87.72,1.2,1.09,1.2.24,0,.49-.25.63-.64Z",
    strokeWidth: 0
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDecline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/decline.412a9dcaed460881ba1366845e87fa5d.svg";